import React, { useEffect } from 'react';
import { RouteList } from '@zg-rentals/route-list';
import { Heading, Page, Spacer, Text } from '@zillow/constellation-10';
import { useMonitor } from '@zg-rentals/rental-manager-env';

const FrontPage = () => {
  const increment = useMonitor();
  useEffect(() => {
    increment({ name: 'render.FrontPage', amount: 1 });
  }, []);
  return (
    <Page.Root>
      <Page.Header>
        <Heading level={3}>user-management-web</Heading>
      </Page.Header>
      <Page.Content>
        <Text>Hello, welcome to user-management-web. 👻</Text>
        <Spacer css={{ marginBlockStart: 'md', marginBlockEnd: 'md' }}>
          {__DEV__ && <RouteList nodeSocketApi="ws://localhost:5001" />}
        </Spacer>
      </Page.Content>
    </Page.Root>
  );
};

export default FrontPage;
